import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Container,
  CardContent,
  Divider,
  Card,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import SearchField from "react-search-field";
import { Tab, Tabs } from "@mui/material";
import Paper from "@mui/material/Paper";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CardHeader1 from "./LabHeader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "@mui/material/IconButton";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import AppCredentials from "./Appcredentials";
import Loadbalancer from "./Loadbalancer";
import StartLab from "./Actions/Startlab";
import StopLab from "./Actions/Stoplab";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#b5b6b7",
    display: "flex",
    height: 280,
  },
  tabs: {
    borderRight: `1px solid`,
    overflow: `visible`,
  },
  title: {
    fontSize: 14,
  },
}));

const Detail = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const guacamole_url = process.env.REACT_APP_GUACAMOLE_URL;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [instancelist, setinstancelist] = useState([]);

  useEffect(() => {
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(
      `${process.env.REACT_APP_API_URL}/api/preconfigdetailedoutputview/${InstanceID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setinstancelist(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [opendelete, setOpendelete] = React.useState(false);

  const handleClickOpenDelete = () => {
    setOpendelete(true);
  };

  const handleCloseDelete = () => {
    setOpendelete(false);
  };

  const Delete = (InstanceID) => {
    return function () {
      window.location.href = "/app/instance";
      fetch(
        `${process.env.REACT_APP_API_URL}/api/hypervisedPreconfiglabs/${InstanceID}/`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          handleCloseDelete();
        })
        .catch((error) => {
          handleCloseDelete();
        });
      handleCloseDelete();
    };
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl(null);
  };

  const open1 = Boolean(anchorEl);

  const id = open1 ? "simple-popover" : undefined;

  const [searchitems, setSearchItems] = React.useState(0);

  const [copied, setCopied] = React.useState(false);

  const [copyanchorEl, setCopyanchorEl] = React.useState(null);

  const handlecopyClick = (event) => {
    setCopyanchorEl(event.currentTarget);
  };

  const handlecopyClose = () => {
    setCopyanchorEl(null);
  };

  const copyopen = Boolean(copyanchorEl);
  const copyid = copyopen ? "simple-popover" : undefined;
  return (
    <>
      {instancelist.map((instancelist) => (
        <React.Fragment>
          <Helmet>
            <title>LabAsService</title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 3,
            }}
          >
            <div
              style={{ alignItems: "center", display: "flex", width: "600px" }}
            >
              <Dialog
                open={opendelete}
                onClose={handleCloseDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Are you sure you want to delete the Lab{" "}
                  <strong style={{ color: "#EF5350" }}>
                    {instancelist.name}
                  </strong>{" "}
                  ?
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description"></DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDelete} color="primary">
                    Disagree
                  </Button>
                  <Button
                    onClick={Delete(instancelist.id)}
                    color="primary"
                    autoFocus
                  >
                    Agree
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              {instancelist.status === "Stopped" ? (
                <StartLab />
              ) : instancelist.status === "Running" ? (
                <StopLab />
              ) : (
                ""
              )}
              <Button
                sx={{ mx: 1 }}
                variant="contained"
                color="secondary"
                startIcon={<DeleteIcon />}
                onClick={handleClickOpenDelete}
              >
                Destroy
              </Button>
            </Box>
            <CardHeader1
              color="primary"
              style={{
                background:
                  "-webkit-linear-gradient(left top, #444458, #7e4aaf)",
                background:
                  "linear-gradient(to bottom right, #444458, #7e4aaf)",
                textAlign: "center",
              }}
            >
              <Typography
                fontWeight="fontWeightBold"
                color="white"
                variant="h5"
              >
                Application: <strong>{instancelist.application} </strong>
              </Typography>
            </CardHeader1>
            <Container maxWidth={false}>
              <Box border={1} sx={{ mt: 1 }}>
                <Card>
                  <CardContent>
                    <Grid container spacing={0}>
                      <Typography
                        color="textPrimary"
                        variant="h6"
                        gutterBottom
                        marginTop={1}
                      >
                        Lab Details
                        <Divider />
                      </Typography>
                      <Grid container spacing={2} marginTop={1} marginLeft={3}>
                        <Grid item xs={3} marginLeft={2}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            Lab Name :
                          </Typography>
                          <Typography
                            variant="h6"
                            fontWeight="fontWeightBold"
                            marginLeft={2}
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            {instancelist.name}
                          </Typography>
                        </Grid>
                        <Grid item xs={3} marginLeft={2}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            Lab Status :
                          </Typography>
                          <Typography
                            variant="h6"
                            marginLeft={2}
                            fontWeight="fontWeightBold"
                            style={{
                              display: "inline-block",
                              color: "#00a200",
                            }}
                            gutterBottom
                          >
                            {instancelist.status}
                          </Typography>
                        </Grid>
                        <Grid item xs={3} marginLeft={2}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            Number of Trainee :
                          </Typography>
                          <Typography
                            variant="h6"
                            marginLeft={2}
                            fontWeight="fontWeightBold"
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            {instancelist.no_of_trainee}
                          </Typography>
                        </Grid>
                      </Grid>
                      <br />
                      <Divider />
                      <br />
                      <Typography
                        color="textPrimary"
                        variant="h6"
                        gutterBottom
                        marginTop={4}
                      >
                        Schedule
                        <Divider />
                      </Typography>
                      <Grid container spacing={1} marginTop={2} marginLeft={1}>
                        <Grid item xs={3} marginLeft={1}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            Schedule Type :
                          </Typography>
                          <Typography
                            fontWeight={500}
                            marginLeft={2}
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >{`${instancelist.depends_on}`}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} marginTop={2} marginLeft={1}>
                        <Grid item xs={2} marginLeft={1}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            Start Date :
                          </Typography>
                          <Typography
                            fontWeight={500}
                            marginLeft={2}
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >{`${instancelist.start_date}`}</Typography>
                        </Grid>
                        <Grid item xs={2} marginLeft={1}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            End Date :
                          </Typography>
                          <Typography
                            style={{ display: "inline-block" }}
                            marginLeft={2}
                            fontWeight={500}
                            gutterBottom
                          >{`${instancelist.end_date}`}</Typography>
                        </Grid>
                        <Grid item xs={2} marginLeft={1}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            Start Time :
                          </Typography>
                          <Typography
                            fontWeight={500}
                            marginLeft={2}
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >{`${instancelist.start_time}`}</Typography>
                        </Grid>
                        <Grid item xs={2} marginLeft={0}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            Stop Time :
                          </Typography>
                          <Typography
                            style={{ display: "inline-block" }}
                            marginLeft={2}
                            fontWeight={500}
                            gutterBottom
                          >{`${instancelist.stop_time}`}</Typography>
                        </Grid>
                      </Grid>

                      <Typography
                        color="textPrimary"
                        variant="h6"
                        gutterBottom
                        marginTop={4}
                      >
                        Instance Credentials
                        <Divider />
                      </Typography>

                      <Grid container spacing={2} marginTop={1} marginLeft={3}>
                        <Grid item xs={3} marginLeft={2}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            User Name :
                          </Typography>
                          <Typography
                            fontWeight={500}
                            style={{ display: "inline-block" }}
                            marginLeft={2}
                            gutterBottom
                          >
                            {instancelist.username}
                          </Typography>
                          <CopyToClipboard
                            text={instancelist.username}
                            onCopy={() => setCopied(true)}
                          >
                            <IconButton
                              aria-label="Filter"
                              color="primary"
                              onClick={handlecopyClick}
                            >
                              <FileCopyOutlinedIcon />
                            </IconButton>
                          </CopyToClipboard>
                          <Popover
                            id={copyid}
                            open={copyopen}
                            anchorEl={copyanchorEl}
                            onClose={handlecopyClose}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                          >
                            <Typography style={{ color: "forestgreen" }}>
                              Copied!.
                            </Typography>
                          </Popover>
                        </Grid>
                        <Grid item xs={3} marginLeft={2}>
                          <Typography
                            style={{ display: "inline-block" }}
                            gutterBottom
                          >
                            Password :
                          </Typography>
                          <Typography
                            fontWeight={500}
                            style={{ display: "inline-block" }}
                            marginLeft={2}
                            gutterBottom
                          >
                            {instancelist.password}
                          </Typography>
                          <CopyToClipboard
                            text={instancelist.password}
                            onCopy={() => setCopied(true)}
                          >
                            <IconButton
                              aria-label="Filter"
                              color="primary"
                              onClick={handlecopyClick}
                            >
                              <FileCopyOutlinedIcon />
                            </IconButton>
                          </CopyToClipboard>
                          <Popover
                            id={copyid}
                            open={copyopen}
                            anchorEl={copyanchorEl}
                            onClose={handlecopyClose}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                          >
                            <Typography style={{ color: "forestgreen" }}>
                              Copied!.
                            </Typography>
                          </Popover>
                        </Grid>
                      </Grid>

                      {instancelist.app_credential !== null ? (
                        <React.Fragment>
                          <Typography
                            color="textPrimary"
                            variant="h6"
                            gutterBottom
                            marginTop={4}
                          >
                            Application Credentials
                            <Divider />
                          </Typography>

                          <Grid
                            container
                            spacing={2}
                            marginTop={1}
                            marginLeft={3}
                          >
                            <AppCredentials
                              credential={instancelist.app_credential}
                            />
                          </Grid>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                      {instancelist.loadbalancer === "yes" ? (
                        <React.Fragment>
                          <Typography
                            color="textPrimary"
                            variant="h6"
                            gutterBottom
                            marginTop={4}
                          >
                            Load Balancer Details
                            <Divider />
                          </Typography>
                          <Grid
                            container
                            spacing={2}
                            marginTop={1}
                            marginLeft={3}
                          >
                            <Loadbalancer loadbalancer={instancelist.lb_data} />
                          </Grid>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </CardContent>
                </Card>
              </Box>
              <Divider />

              <Box border={1} sx={{ mt: 1 }} paddingBottom={0} paddingTop={0}>
                <Card>
                  <CardHeader
                    subheader={
                      <SearchField
                        value={searchitems}
                        placeholder="Search..."
                        onChange={(event) => {
                          setSearchItems(event);
                        }}
                        classNames="test-class"
                      />
                    }
                  />
                  <Divider />

                  <CardContent>
                    <Box sx={{ flexGrow: 1, display: "flex", height: 500 }}>
                      <Tabs
                        orientation="vertical"
                        value={value}
                        variant="scrollable"
                        scrollButtons="auto"
                        onChange={handleChange}
                        aria-label="Vertical tabs example"
                        sx={{
                          borderRight: 1,
                          borderColor: "divider",
                          minWidth: "250px",
                        }}
                      >
                        {instancelist.Instance_info.filter((val) => {
                          if (searchitems == "") {
                            return val;
                          } else if (
                            val.name
                              .toLowerCase()
                              .includes(searchitems.toLowerCase())
                          ) {
                            return val;
                          }
                        }).map((instance_info, i) => (
                          <Tab label={instance_info.name} {...a11yProps(i)} />
                        ))}
                      </Tabs>

                      <PerfectScrollbar>
                        <Card>
                          <CardContent>
                            {instancelist.Instance_info.filter((val) => {
                              if (searchitems == "") {
                                return val;
                              } else if (
                                val.name
                                  .toLowerCase()
                                  .includes(searchitems.toLowerCase())
                              ) {
                                return val;
                              }
                            }).map((instance_info, i) => (
                              <React.Fragment>
                                <TabPanel value={value} index={i}>
                                  <Grid
                                    container
                                    spacing={1}
                                    marginTop={2}
                                    marginBottom={4}
                                    marginLeft={0}
                                  >
                                    <Grid item xs={12} marginLeft={0}>
                                      <Typography
                                        style={{ display: "inline-block" }}
                                        gutterBottom
                                      >
                                        guacamole url :
                                      </Typography>
                                      <Typography
                                        fontWeight={500}
                                        marginLeft={1}
                                        style={{ display: "inline-block" }}
                                        gutterBottom
                                      >
                                        {guacamole_url}
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={7} marginLeft={0}>
                                      <Typography
                                        style={{ display: "inline-block" }}
                                        gutterBottom
                                      >
                                        Username :
                                      </Typography>
                                      <Typography
                                        fontWeight={500}
                                        marginLeft={1}
                                        style={{ display: "inline-block" }}
                                        gutterBottom
                                      >
                                        {instancelist.name}-{instance_info.name}
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={5} marginLeft={0}>
                                      <Typography
                                        style={{ display: "inline-block" }}
                                        gutterBottom
                                      >
                                        Password :
                                      </Typography>
                                      <Typography
                                        style={{ display: "inline-block" }}
                                        marginLeft={2}
                                        fontWeight={500}
                                        gutterBottom
                                      >
                                        zippyops
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  <TableContainer component={Paper}>
                                    <Table
                                      style={{ width: 1700 }}
                                      size="medium"
                                      aria-label="a dense table"
                                    >
                                      <TableHead>
                                        <TableRow>
                                          <TableCell align="left">
                                            name
                                          </TableCell>
                                          <TableCell align="left">
                                            Public address
                                          </TableCell>
                                          <TableCell align="left">
                                            Private address
                                          </TableCell>
                                          <TableCell align="left">
                                            status
                                          </TableCell>
                                          <TableCell align="left">
                                            Machine Type
                                          </TableCell>
                                          <TableCell align="left">
                                            OS Type
                                          </TableCell>
                                          <TableCell align="left">
                                            Storage
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {instance_info.details.map(
                                          (details) => (
                                            <React.Fragment>
                                              <TableRow key={details.key}>
                                                <TableCell
                                                  align="left"
                                                  component="th"
                                                  scope="row"
                                                >
                                                  {details.key}
                                                </TableCell>
                                                <TableCell align="left">
                                                  {details.public_ip_address}
                                                  <CopyToClipboard
                                                    text={
                                                      details.public_ip_address
                                                    }
                                                    onCopy={() =>
                                                      setCopied(true)
                                                    }
                                                  >
                                                    <IconButton
                                                      aria-label="Filter"
                                                      color="primary"
                                                      onClick={handleClick}
                                                    >
                                                      <FileCopyOutlinedIcon />
                                                    </IconButton>
                                                  </CopyToClipboard>
                                                  <Popover
                                                    id={id}
                                                    open={open1}
                                                    anchorEl={anchorEl}
                                                    onClose={handleClose1}
                                                    anchorOrigin={{
                                                      vertical: "bottom",
                                                      horizontal: "center",
                                                    }}
                                                    transformOrigin={{
                                                      vertical: "top",
                                                      horizontal: "center",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "forestgreen",
                                                      }}
                                                    >
                                                      Copied!.
                                                    </Typography>
                                                  </Popover>
                                                </TableCell>
                                                <TableCell align="left">
                                                  {details.private_ip_address}
                                                  <CopyToClipboard
                                                    text={
                                                      details.private_ip_address
                                                    }
                                                    onCopy={() =>
                                                      setCopied(true)
                                                    }
                                                  >
                                                    <IconButton
                                                      aria-label="Filter"
                                                      color="primary"
                                                      onClick={handleClick}
                                                    >
                                                      <FileCopyOutlinedIcon />
                                                    </IconButton>
                                                  </CopyToClipboard>
                                                  <Popover
                                                    id={id}
                                                    open={open1}
                                                    anchorEl={anchorEl}
                                                    onClose={handleClose1}
                                                    anchorOrigin={{
                                                      vertical: "bottom",
                                                      horizontal: "center",
                                                    }}
                                                    transformOrigin={{
                                                      vertical: "top",
                                                      horizontal: "center",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "forestgreen",
                                                      }}
                                                    >
                                                      Copied!.
                                                    </Typography>
                                                  </Popover>
                                                </TableCell>
                                                <TableCell align="left">
                                                  {details.status ===
                                                  "Creating" ? (
                                                    <Typography
                                                      variant="h6"
                                                      marginLeft={2}
                                                      fontWeight="fontWeightBold"
                                                      style={{
                                                        display: "inline-block",
                                                        color: "#2234E8",
                                                      }}
                                                      marginLeft={1}
                                                      gutterBottom
                                                    >
                                                      {details.status}
                                                    </Typography>
                                                  ) : details.status ===
                                                      "Running" ||
                                                    details.status ===
                                                      "running" ? (
                                                    <Typography
                                                      variant="h6"
                                                      marginLeft={2}
                                                      fontWeight="fontWeightBold"
                                                      style={{
                                                        display: "inline-block",
                                                        color: "#209508",
                                                      }}
                                                      marginLeft={1}
                                                      gutterBottom
                                                    >
                                                      {details.status}
                                                    </Typography>
                                                  ) : details.status ===
                                                      "Stopped" ||
                                                    details.status ===
                                                      "stopped" ? (
                                                    <Typography
                                                      variant="h6"
                                                      marginLeft={2}
                                                      fontWeight="fontWeightBold"
                                                      style={{
                                                        display: "inline-block",
                                                        color: "#D73206",
                                                      }}
                                                      marginLeft={1}
                                                      gutterBottom
                                                    >
                                                      {details.status}
                                                    </Typography>
                                                  ) : details.status ===
                                                      "Stoping" ||
                                                    details.status ===
                                                      "stoping" ? (
                                                    <Typography
                                                      variant="h6"
                                                      marginLeft={2}
                                                      fontWeight="fontWeightBold"
                                                      style={{
                                                        display: "inline-block",
                                                        color: "#F3AF05",
                                                      }}
                                                      marginLeft={1}
                                                      gutterBottom
                                                    >
                                                      {details.status}
                                                    </Typography>
                                                  ) : (
                                                    ""
                                                  )}
                                                </TableCell>
                                                <TableCell align="left">
                                                  {details.instance_type}
                                                </TableCell>
                                                <TableCell align="left">
                                                  {details.ostype}
                                                </TableCell>
                                                <TableCell align="left">
                                                  {details.storage}
                                                </TableCell>
                                              </TableRow>
                                            </React.Fragment>
                                          )
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </TabPanel>
                              </React.Fragment>
                            ))}
                          </CardContent>
                        </Card>
                      </PerfectScrollbar>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </Container>
          </Box>
        </React.Fragment>
      ))}
    </>
  );
};

export default Detail;
